// Auto generated. Use `npm run icons` to regenerate.

// fad
import {
  faArrowRightArrowLeft as fadArrowRightArrowLeft,
  faHome as fadHome,
  faTruckFast as fadTruckFast,
  faWebhook as fadWebhook,
} from "@fortawesome/pro-duotone-svg-icons";

// fal
import {
  faArrowLeft as falArrowLeft,
  faArrowsRotate as falArrowsRotate,
  faBars as falBars,
  faBoxOpen as falBoxOpen,
  faFiles as falFiles,
  faGear as falGear,
  faLanguage as falLanguage,
  faMagnifyingGlass as falMagnifyingGlass,
  faPowerOff as falPowerOff,
  faTriangleExclamation as falTriangleExclamation,
} from "@fortawesome/pro-light-svg-icons";

// fas
import {
  faArrowRight as fasArrowRight,
  faBell as fasBell,
  faCheck as fasCheck,
  faPencil as fasPencil,
  faPlus as fasPlus,
  faTimes as fasTimes,
  faTrash as fasTrash,
} from "@fortawesome/pro-solid-svg-icons";

import { library, config } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

// This is important, we are going to let Nuxt worry about the CSS
config.autoAddCss = false

library.add(
  fadArrowRightArrowLeft,
  fadHome,
  fadTruckFast,
  fadWebhook,
  falArrowLeft,
  falArrowsRotate,
  falBars,
  falBoxOpen,
  falFiles,
  falGear,
  falLanguage,
  falMagnifyingGlass,
  falPowerOff,
  falTriangleExclamation,
  fasArrowRight,
  fasBell,
  fasCheck,
  fasPencil,
  fasPlus,
  fasTimes,
  fasTrash
);

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('fa', FontAwesomeIcon, {})
})
